import { render, staticRenderFns } from "./ChatAdminProfile.vue?vue&type=template&id=682548b3&"
import script from "./ChatAdminProfile.vue?vue&type=script&lang=js&"
export * from "./ChatAdminProfile.vue?vue&type=script&lang=js&"
import style0 from "./ChatAdminProfile.vue?vue&type=style&index=0&id=682548b3&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports